import React, {useEffect} from 'react';
import {PerspectiveCamera} from 'three';
import {useFrame} from '@react-three/fiber';
import {useARStore} from 'stores';
import {useInputStates} from 'hooks';
import {move, rotate} from 'utils';

import ARModel from './AR.Model';

interface IARModelsProps {}

const ARModels = ({}: IARModelsProps) => {
  const camera = useARStore(s => s.cameraRef.current) as PerspectiveCamera;
  const models = useARStore(s => s.models);
  const modelActive = useARStore(s => s.modelActive);
  const isModelInteractiveRef = useARStore(s => s.isModelInteractiveRef);
  const setFieldOfView = useARStore(s => s.setFieldOfView);

  const {stateRef} = useInputStates();

  useFrame(() => {
    (async () => {
      if (!isModelInteractiveRef.current || !modelActive.ref.current) {
        return;
      }
      if (stateRef.current === 'move') {
        const position = await move.run();
        // The states are rechecked as it's possible to be out of sync,
        // caused by the long running await operations.
        if (stateRef.current === 'move') {
          position && modelActive.ref.current.position.copy(position);
        }
      }
      if (stateRef.current === 'rotate') {
        const angle = await rotate.run();
        // The states are rechecked as it's possible to be out of sync,
        // caused by the long running await operations.
        if (stateRef.current === 'rotate') {
          angle && modelActive.ref.current.rotateY(angle);
        }
      } else {
        rotate.reset();
      }
    })();
  });

  useEffect(() => {
    if (camera.isPerspectiveCamera) {
      setFieldOfView(camera);
    }
  }, [camera.fov, setFieldOfView]);

  return (
    <>
      {models.map(model => {
        return <ARModel key={model.id} model={model} modelActive={modelActive} />;
      })}
    </>
  );
};

export default React.memo(ARModels);
